// extracted by mini-css-extract-plugin
module.exports = {"box":"address_box__Rtg3T"};